import { Action, Dispatch } from "redux";
import { SiteSetting } from "../models/settings.model";
import { UpdatePageAction, UPDATE_PAGE } from "./page.actions";
import fetchSiteSettings from "../helpers/fetchSiteSettings";

export const GET_SITE_SETTINGS = "GET_SITE_SETTINGS";

export interface GetSiteSettingsAction extends Action {
    type: typeof GET_SITE_SETTINGS;
    content: SiteSetting;
    [key: string]: any;
}

let siteSettingsCache: Promise<any> | undefined = undefined;
export const thunkGetSiteSettings =
    (url: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        try {
            if (!url) {
                throw new Error();
            }

            // Check for cached site settings.
            const request = typeof siteSettingsCache !== "undefined" ? siteSettingsCache : fetchSiteSettings(url);
            siteSettingsCache = request;

            const response = await request;

            if (response && response._contentType === "siteSettings") {
                const action: GetSiteSettingsAction = {
                    type: GET_SITE_SETTINGS,
                    content: response,
                };

                dispatch(action);
            }
        } catch {
            const action: UpdatePageAction = {
                type: UPDATE_PAGE,
                content: {
                    _contentType: "errorPage",
                    _name: "An error occured",
                    _url: url,
                },
                statusCode: 500,
            };

            dispatch(action);
        }
    };

export type SiteSettingsAction = GetSiteSettingsAction;
